/**
 * KPI codes that should not display "View Info" link
 */
export const NO_INFO_KPI_CODES = ['HDLW', 'YOYT', 'CPI', 'BOPI', 'BODF', 'ASSM', 'CPI7'];

/**
 * KPI codes that should not display GOAL
 */
export const NO_GOAL_KPI_CODES = ['PEFF'];

/**
 * KPI codes that should not display GOAL in multi-store mode
 */
export const NO_GOAL_KPI_CODES_MS = ['EEYC','SFTH'];

/**
 * KPI codes for  CUSTOMER Insight Program
 */
export const INSIGHT_PROGRAM_KPI_CODES = ['OSAT', 'SARD'];

/**
 * KPI codes that should not display metric value and instead show "No Metric" chip
 */
export const NO_METRIC_KPI_CODES = ['MGIR', 'MGIS'];

/**
 * KPI codes that should not display "Take Action" button when current value is zero or null, and instead show a dash ("-")
 */
export const NO_ZERO_CURRENT_VALUE_KPI_CODES = ['AHF','BTYG','BDGC','BTAC','CPI7','CRPC','DA','HRAS','INST','MGIS','MGMA','MGOB','OPTI','OSAT','SARD','SFTH'];

/**
 * KPI codes that should not display actions in multi-store mode
 */
export const NO_MULTISTORE_MODE_KPI_CODES = ['BDGC', 'HRAS', 'SFTH'];

/** 
 * Special KPI cell values that require chip rendering (Risk indicators)
 */
export const KPI_SPECIAL_VALUES = ['Risk'];

/**
 * KPI format types for value display
 */
export const KPI_FORMAT = {
  PERCENTAGE: 'PCT',
  DOLLAR: 'DOL',
  NUMBER: 'NUM',
} as const;

/**
 * Goal flag values indicating KPI performance
 */
export const GOAL_FLAG = {
  MET: 'Y',
  NOT_MET: 'N',
  AT_RISK: 'O',
} as const;

/**
 * Card title identifiers for KPI components
 */
export const CARD_TITLES = {
  MARKETING: 'Marketing' as const,
  PEOPLE: 'People' as const,
  B2B: 'B2B' as const,
  ECOMMERCE: 'Ecommerce' as const,
  INVENTORY: 'Inventory' as const,
} as const;

/**
 * User permission identifiers
 */
export const PERMISSIONS = {
  MARKETING_PLANNING_TOOL: 'Marketing_Planning_Tool_Application_Access',
  CONFIDENTIAL_CONTENT_READ_ONLY: 'Confidentialcontent-read_only',
} as const;

/**
 * KPI codes that are flagged as Mango Reports
 */
export const MANGO_REPORT_KPI = [
  'EOQMS',
  'MGAC',
  'MGIR',
  'MGIS',
  'MGMA',
  'MGOB',
  'MGOS',
  'MGUP',
] as const;

/**
 * *Order each cards grids should be displayed in - this is used in the selectKpiGridsByCardName selector to sort grids consistently by card
 * */
export const GRID_ORDER_BY_CARD: Record<string, string[]> = {
  INVENTORY: [
    'Assortment and Pricing',
    'Optimal Shelf Quantity',
    'Inventory Accuracy',
    'Unproductive Inventory',
  ],
  MARKETING: ['Ace Rewards', 'Local Marketing', 'Ecommerce', 'Store Hours'],
  PEOPLE: [
    'Customer Satisfaction',
    'Employee Engagement',
    'Training',
    'Attachment Rate',
    'CMN FUNDRAISING',
  ],
};
/**
 * Decimal places configuration for KPI values in LineGraph components
 * Used to control precision of main value, trend indicator, and tooltips
 * undefined = use default behavior (2 decimals if value has decimals, 0 otherwise)
 */
export const KPI_DECIMAL_PLACES: Record<string, number | undefined> = {
  TSALE: 0, // Total Sales
  SALES: 0, // In Store Sales
  ESALE: 0, // Ecom Sales
  SLSSF: 2, // Sales Per S/F
  GP: 0, // In Store Gross Profit
  EGP: 0, // Ecom Gross Profit
  GPSF: 2, // Gross Profit Per S/F
  GM: 1, // Gross Margin %
  EGM: 1, // Ecom Gross Margin %
  ATS: 2, // Average Transaction (currency with cents)
  TCNT: 0, // Transaction Count (whole number)
  ECNT: 0, // Ecom Transaction Count (whole number)
  TUNIT: 2, // Units Per Transaction
  IVALU: 0, // Inventory Value
  B2S: 0, // B2B Sales
  B2P: 0, // B2B Gross Profit
  B2T: 0, // B2B Transactions
  RDI: 0, // Reward Dollars Issued
  RDO: 0, // Reward Dollars Outstanding
  RDR: 0, // Reward Dollars Redeemed
} as const;

/**
 * Decimal places configuration for percentage changes in trend indicators
 * Used to control precision of percentage change values (e.g., "(5.2%)" vs "(5.23%)")
 * Independent of main value precision to allow different formatting requirements
 * Default: 2 decimal places for percentage change
 */
export const KPI_PERCENTAGE_DECIMAL_PLACES: Record<string, number | undefined> = {
  TSALE: 1,
  SALES: 1,
  ESALE: 1,
  SLSSF: 1,
  GM: 1,
  EGM: 1,
  ATS: 1,
  TCNT: 1,
  ECNT: 1,
  TUNIT: 1,
} as const;
